import React, { PropTypes } from 'react'
import cx from 'classnames'

import './InputControl.scss'

export const generateId = (input = {}) => input.name

const InputControl = (props) => {
  const {
    label,
    type,
    icon,
    input,
    className,
    meta: {
      active,
      touched,
      error
    }
  } = props

  const controlClasses = cx({
    'InputControl': true,
    'InputControl-state-error': error && touched,
    'InputControl-state-focused': active || input.value,
    'InputControl-hasIcon': icon,
    [className]: className
  })

  const id = generateId(input)

  return (
    <div className={controlClasses}>
      {label && <label htmlFor={id} className='InputControl-label'>{label}</label>}
      <div className='InputControl-wrapper'>
        {icon && <span className={`InputControl-icon icon-${icon}`} />}
        <input {...input} id={id} type={type} className='InputControl-input' />
      </div>
      {touched && (error && <div className='InputControl-error'>{error}</div>)}
    </div>
  )
}

InputControl.displayName = 'InputControl'

InputControl.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  icon: PropTypes.string,
  meta: PropTypes.object,
  input: PropTypes.object.isRequired,
  className: PropTypes.string
}

InputControl.defaultProps = {
  type: 'text',
  className: undefined
}

export default InputControl



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/InputControl/InputControl.js